import React from "react";

import { GridColumn, GridItem, GridRow } from "commons/ui/Grid";
import InputText from "commons/ui/input/InputText";
import LineSeparator from "commons/ui/LineSeparator";

import TwoLanguagesAdornment from "components/subComponents/TwoLanguagesAdornment";
import AttachmentPicker from "components/ui/AttachmentPicker";
import TitleFunctionsTopBlock from "components/ui/TitleFunctionsTopBlock";

import useCheckSectionErrors from "hooks/form/blocks/useCheckSectionErrors";
import useSectionThreeImagesEightTexts from "hooks/form/blocks/useSectionThreeImagesEightTexts";
import useTitleFunctionsTopBlock from "hooks/useTitleFunctionsTopBlock";

import { DesktopOrMobile } from "types/enums";

function SectionThreeImagesTwoTexts() {
    const { buttonDelete, setBackgroundImage, setFirstImage, setSecondImage, formHook } =
        useSectionThreeImagesEightTexts();

    useCheckSectionErrors({ formHook });

    const { checkErrorVisibility, setValue, form } = formHook;

    const titleFunctionsTopBlockHook = useTitleFunctionsTopBlock({
        buttonDelete: buttonDelete,
    });

    return (
        <>
            <TitleFunctionsTopBlock titleFunctionsTopBlockHook={titleFunctionsTopBlockHook} />

            {titleFunctionsTopBlockHook.closedBlock && (
                <>
                    <GridColumn>
                        <GridRow>
                            <div className={"col-xxl-12-6 col-xl-12-12 col-xs-12-12"}>
                                <GridRow>
                                    <GridItem>
                                        <h3>Prima immagine</h3>
                                    </GridItem>
                                </GridRow>

                                <GridRow>
                                    <GridItem className={"col-xs-12-6"}>
                                        <AttachmentPicker
                                            buttonLabel={"Foto Desktop"}
                                            setFile={(file) =>
                                                setFirstImage(file, DesktopOrMobile.desktop)
                                            }
                                            file={form.img_one.desktop}
                                            accept={".png,.jpg,.jpeg"}
                                            errors={checkErrorVisibility("img_one.desktop")}
                                        />
                                    </GridItem>

                                    <GridItem className={"col-xs-12-6"}>
                                        <AttachmentPicker
                                            buttonLabel={"Foto Mobile"}
                                            setFile={(file) =>
                                                setFirstImage(file, DesktopOrMobile.mobile)
                                            }
                                            file={form.img_one.mobile}
                                            accept={".png,.jpg,.jpeg"}
                                            errors={checkErrorVisibility("img_one.mobile")}
                                        />
                                    </GridItem>
                                </GridRow>
                            </div>

                            <div className={"col-xxl-12-6 col-xl-12-12 col-xs-12-12"}>
                                <GridRow>
                                    <GridItem>
                                        <h3>Seconda immagine</h3>
                                    </GridItem>
                                </GridRow>

                                <GridRow>
                                    <GridItem className={"col-xs-12-6"}>
                                        <AttachmentPicker
                                            buttonLabel={"Foto Desktop"}
                                            setFile={(file) =>
                                                setSecondImage(file, DesktopOrMobile.desktop)
                                            }
                                            file={form.img_two.desktop}
                                            accept={".png,.jpg,.jpeg"}
                                            errors={checkErrorVisibility("img_two.desktop")}
                                        />
                                    </GridItem>

                                    <GridItem className={"col-xs-12-6"}>
                                        <AttachmentPicker
                                            buttonLabel={"Foto Mobile"}
                                            setFile={(file) =>
                                                setSecondImage(file, DesktopOrMobile.mobile)
                                            }
                                            file={form.img_two.mobile}
                                            accept={".png,.jpg,.jpeg"}
                                            errors={checkErrorVisibility("img_two.mobile")}
                                        />
                                    </GridItem>
                                </GridRow>
                            </div>

                            <div className={"col-xxl-12-6 col-xl-12-12 col-xs-12-12"}>
                                <GridRow>
                                    <GridItem>
                                        <h3>Immagine di Background</h3>
                                    </GridItem>
                                </GridRow>

                                <GridRow>
                                    <GridItem className={"col-xs-12-6"}>
                                        <AttachmentPicker
                                            buttonLabel={"Foto Desktop"}
                                            setFile={(file) =>
                                                setBackgroundImage(file, DesktopOrMobile.desktop)
                                            }
                                            file={form.img_background.desktop}
                                            accept={".png,.jpg,.jpeg"}
                                            errors={checkErrorVisibility("img_background.desktop")}
                                        />
                                    </GridItem>

                                    <GridItem className={"col-xs-12-6"}>
                                        <AttachmentPicker
                                            buttonLabel={"Foto Mobile"}
                                            setFile={(file) =>
                                                setBackgroundImage(file, DesktopOrMobile.mobile)
                                            }
                                            file={form.img_background.mobile}
                                            accept={".png,.jpg,.jpeg"}
                                            errors={checkErrorVisibility("img_background.mobile")}
                                        />
                                    </GridItem>
                                </GridRow>
                            </div>
                        </GridRow>
                    </GridColumn>

                    <LineSeparator />

                    <GridColumn>
                        <GridRow>
                            <GridItem className={"col-xs-12-12"}>
                                <h3>Testi</h3>
                            </GridItem>
                        </GridRow>

                        <GridRow>
                            <GridItem>
                                <span>Inserisci i testi per tutte le lingue</span>
                            </GridItem>
                        </GridRow>
                    </GridColumn>

                    <GridColumn>
                        <GridRow>
                            <div className={"col-xs-12-6"}>
                                <GridRow>
                                    <GridItem className={"col-xs-12-12"}>
                                        <InputText
                                            label={"Primo paragrafo"}
                                            startAdornment={TwoLanguagesAdornment("it")}
                                            value={form.text.it.title_1}
                                            setValue={setValue}
                                            path={"text.it.title_1"}
                                            checkErrorVisibility={checkErrorVisibility}
                                            textarea
                                            largeBox
                                        />
                                    </GridItem>
                                </GridRow>

                                <GridRow>
                                    <GridItem className={"col-xs-12-12"}>
                                        <InputText
                                            label={"Secondo paragrafo"}
                                            startAdornment={TwoLanguagesAdornment("it")}
                                            value={form.text.it.title_2}
                                            setValue={setValue}
                                            path={"text.it.title_2"}
                                            checkErrorVisibility={checkErrorVisibility}
                                            textarea
                                            largeBox
                                        />
                                    </GridItem>
                                </GridRow>
                            </div>

                            <div className={"col-xs-12-6"}>
                                <GridRow>
                                    <GridItem className={"col-xs-12-12"}>
                                        <InputText
                                            label={"Primo Paragrafo"}
                                            startAdornment={TwoLanguagesAdornment("en")}
                                            value={form.text.en.title_1}
                                            setValue={setValue}
                                            path={"text.en.title_1"}
                                            checkErrorVisibility={checkErrorVisibility}
                                            textarea
                                            largeBox
                                        />
                                    </GridItem>
                                </GridRow>

                                <GridRow>
                                    <GridItem className={"col-xs-12-12"}>
                                        <InputText
                                            label={"Secondo paragrafo"}
                                            startAdornment={TwoLanguagesAdornment("en")}
                                            value={form.text.en.title_2}
                                            setValue={setValue}
                                            path={"text.en.title_2"}
                                            checkErrorVisibility={checkErrorVisibility}
                                            textarea
                                            largeBox
                                        />
                                    </GridItem>
                                </GridRow>
                            </div>
                        </GridRow>
                    </GridColumn>
                </>
            )}
        </>
    );
}

export default SectionThreeImagesTwoTexts;
